import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

interface InfoPairProps {
  label: string;
  value?: string;
  isLoading?: boolean;
}

export const InfoPair = ({ label, value, isLoading }: InfoPairProps) => (
  <Stack align="start" gap={0} className="min-w-0 flex-1">
    <Text variant="caption" tone="muted">
      {label}
    </Text>
    {isLoading ? (
      <Skeleton className="mt-1 h-6 w-8" />
    ) : (
      <Text variant="heading">{value}</Text>
    )}
  </Stack>
);
